import { makeRecord } from "sdi/source";
import { fromRecord } from "sdi/locale";

export function attribution() {
  return `Géoportail des Interventions Agri-Climat-Environnement en RDC`;
}

export function credits() {
  return fromRecord(makeRecord("Fond de plan: \n(c) OpenStreetMap"));
}
